import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-ce99b398")
const _hoisted_1 = { class: "page--limited" }
const _hoisted_2 = { class: "p-grid" }
const _hoisted_3 = { class: "p-col" }
const _hoisted_4 = { class: "p-mt-3" }
const _hoisted_5 = { class: "p-fluid p-field-radiobutton" }
const _hoisted_6 = { class: "w100 p-ml-3" }
const _hoisted_7 = { class: "p-mt-3" }
const _hoisted_8 = { class: "p-fluid p-field-radiobutton" }
const _hoisted_9 = { class: "w100 p-ml-3" }
const _hoisted_10 = { class: "p-col" }
const _hoisted_11 = { class: "p-fluid" }
const _hoisted_12 = {
  key: 0,
  class: "p-mb-3"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_UserAutocomplete = _resolveComponent("UserAutocomplete")!
  const _component_ShiftAutocomplete = _resolveComponent("ShiftAutocomplete")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_MessageEditor = _resolveComponent("MessageEditor")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t('text.title')), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createVNode(_component_Panel, { header: "Targets" }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_RadioButton, {
                    name: "target",
                    value: "user",
                    modelValue: _ctx.target,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.target = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_UserAutocomplete, {
                      modelValue: _ctx.user,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.user = $event)),
                      disabled: _ctx.target !== 'user'
                    }, null, 8, ["modelValue", "disabled"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_RadioButton, {
                    name: "target",
                    value: "shift",
                    modelValue: _ctx.target,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.target = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_ShiftAutocomplete, {
                      modelValue: _ctx.shift,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.shift = $event)),
                      disabled: _ctx.target !== 'shift'
                    }, null, 8, ["modelValue", "disabled"])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("section", _hoisted_10, [
        _createVNode(_component_Panel, { header: "Message" }, {
          default: _withCtx(() => [
            _createVNode(_component_MessageEditor, {
              message: _ctx.message,
              "onUpdate:message": _cache[4] || (_cache[4] = ($event: any) => (_ctx.message = $event))
            }, null, 8, ["message"]),
            _createElementVNode("footer", _hoisted_11, [
              (_ctx.requestPending)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createVNode(_component_ProgressBar, {
                      mode: "indeterminate",
                      style: {"height":".5em"}
                    })
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_Button, {
                label: "Send",
                icon: "pi pi-send",
                onClick: _ctx.send
              }, null, 8, ["onClick"])
            ])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}